export default __webpack_public_path__ + "static/media/480_dummy2016-schneiderei01-mobile-de.70ee88d2.png";